// extracted by mini-css-extract-plugin
export default {"imageWrapper":"CD-z","hovered":"DD-z","hoverImage":"ED-z","mainImage":"FD-z","imageNoBackground":"GD-z","fullSizeImage":"HD-z"};